<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>Card Number</th>
                <th>Description</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="card in cards"
                :key="card.card_number">
                <td>
                    {{ card.card_number }}
                    <template v-if="card.card">
                        <br />Exp: {{ card.card.exp_month }}/{{ card.card.exp_year }} CVC: {{ card.card.cvc }}
                    </template>
                </td>
                <td>
                    <img v-if="card.card_type_ref"
                         :src="`/epos/img/card-types/${card.card_type_ref}.png`"
                         :alt="card.payment_method"
                         class="mr-05"
                         style="height: 1.5rem;" />
                    <strong>{{ card.payment_method }}</strong>
                    <br />
                    {{ card.description }}
                </td>
                <td>
                    <SquareBtn size="xs"
                               :color="btnColor"
                               :loading="card.card_number === simulatingCardNumber"
                               :disabled="!!simulatingCardNumber"
                               @click="$emit('simulate', card)">
                        Simulate
                    </SquareBtn>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';

export default {
    components: {
        SquareBtn,
    },

    props: {
        cards: {
            type: Array,
            required: true,
        },

        btnColor: {
            type: String,
            required: true,
        },

        simulatingCardNumber: {
            type: String,
            default: null,
        },
    },

    emits: ['simulate'],
};
</script>
